module.exports = __webpack_public_path__ + "img/bard.42492d36.png";